export default {
    config: {
        // url: window.location.href.indexOf('test') > 0 ? 'http://www.hd.test.dajiuxing.com.cn' : 'http://www.hd.dajiuxing.com.cn',
        url: window.location.href.indexOf('test') > 0 ? 'http://www.test.dajiuxing.com.cn' : 'https://www.dajiuxing.com.cn',
        urlApi: window.location.href.indexOf('test') > 0 ? 'http://api.test.dajiuxing.com.cn' : 'https://api.dajiuxing.com.cn',
        // url:'https://www.dajiuxing.com.cn',
        // urlApi: 'https://api.dajiuxing.com.cn',
        api: ''  //打包去除api
        // api: '/api' //本地运行+/api/
    },
    format: function(timestamp){
        var date = new Date(timestamp);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    }
}



// WEBPACK FOOTER //
// ./src/util/util.js